import React from 'react';
import QuestionsAndAnswers from './QuestionsAndAnswers';
import { Event, Invitation, Person } from '../interfaces';
import styles from './styles.scss';

type RsvpStatus = 'Attending' | 'Invited' | 'Declined';

const ATTEND: string = 'Attending' as const;
const INVITED: string = 'Invited' as const;
const DECLINED: string = 'Declined' as const;

interface RsvpStatusLabelProps {
  invitation: Invitation;
}

const RsvpStatusLabel: React.FC<RsvpStatusLabelProps> = ({ invitation }) => {
  const { rsvp } = invitation;
  const determineStatus = React.useCallback(() => {
    if (rsvp === undefined || rsvp === null) return INVITED;
    if (rsvp === false) return DECLINED;
    return ATTEND;
  }, [rsvp]);

  const status = determineStatus() as RsvpStatus;

  const statusClass = {
    [ATTEND]: 'attend',
    [DECLINED]: 'decline',
    [INVITED]: 'invited',
  };
  return <div className={styles[statusClass[status]]}>{status}</div>;
};

interface InvitationAnswersProps {
  event: Event;
  guest: Person;
}

const InvitationAnswers: React.FC<InvitationAnswersProps> = ({ event, guest }) => {
  const invite = React.useMemo(() => guest.invitations.find(inv => inv.eventId === event.id), [
    event.id,
    guest.invitations,
  ]);
  if (!invite) return null;

  const guestName = `${guest.firstName || ''} ${guest.lastName || ''}`;
  if (!guestName.trim()) return null;

  const { answers: inviteAnswers = null } = invite;
  const { questions: eventQuestions = null } = event;

  const showQA = !!(invite.rsvp && event.questions?.length);

  return (
    <>
      <div className={styles.guestName}>
        {guestName}
        <RsvpStatusLabel invitation={invite} />
      </div>
      {showQA && <QuestionsAndAnswers questions={eventQuestions} answers={inviteAnswers} />}
    </>
  );
};

export default InvitationAnswers;
